import * as React from "react";

import { IHookProps } from "./props";
import { IHookHandlers } from "./handlers";
import { VingleURL } from "@vingle/wtf-sdk/url";

export default function useEffects(props: IHookProps, handlers: IHookHandlers) {
  const {
    cancelToken,
    dispatchClearDiscover,
    dispatchSelectTrendingSection,
    dispatchGetDiscoverTrendingSections,
    dispatchGetDiscoverFeedCategories,
    history,
  } = props;
  const { handleLoadFeedData } = handlers;
  React.useEffect(() => {
    dispatchClearDiscover();
    dispatchGetDiscoverTrendingSections({
      cancelToken: cancelToken.current.token,
    });
    handleLoadFeedData();
    dispatchGetDiscoverFeedCategories({
      cancelToken: cancelToken.current.token,
    });
    const listener = history.listen(location => {
      if (VingleURL.Discover.isSameExact(location.pathname)) {
        dispatchSelectTrendingSection({
          sectionId: null,
        });
      }
      const match = VingleURL.DiscoverTrendingSection.matchExact(
        location.pathname,
      );
      if (match && match.params.sectionId) {
        dispatchSelectTrendingSection({
          sectionId: match.params.sectionId,
        });
      }
    });
    return () => {
      listener();
      dispatchSelectTrendingSection({
        sectionId: null,
      });
    };
  }, []);
}
